module.exports = __webpack_public_path__ + "img/top_banner.5c3f6ac9.png";